import { FC} from "react";
import { BenefitSummaryType } from "./types";
// import useFetch from "../../hooks/useFetch";
// import { DownloadZipResponseType } from "../../pages/dashboard/types";
// import { APIEndpoints } from "../../types/apiTypes";
// import { LoaderContext } from "../../context/loaderContext";
// import { downloadPdfFile } from "src/helpers/downloadFile";
import { formatPhoneNumber } from "src/helpers";

const ZilrettaDetailPageInfo: FC<BenefitSummaryType> = ({ benefit_summary, coverage_summary, caseObject, isCasePage, drug_name, isPatient, pharmacy_benefit_summary }): JSX.Element => {
  // const { setLoader, hideLoader } = useContext(LoaderContext);
  // console.log(pharmacy_benefit_summary)
  // const {
  //   data: downloadCaseData,
  //   error: downloadCaseError,
  //   mutate: downloadRequestForm,
  //   removeErrorAndData: clearRequestFileData,
  // } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  // useEffect(() => {
  //   if (downloadCaseData || downloadCaseError) {
  //     if (downloadCaseData) {
  //       const { response, report_name } = downloadCaseData;
  //       downloadPdfFile(response, report_name);
  //     }
  //     hideLoader();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [downloadCaseData, downloadCaseError]);

  // const downloadFileByCaseId = (insuranceId: string) => {
  //   if (downloadCaseData || downloadCaseError) clearRequestFileData();
  //   setLoader();

  //   if (caseObject && caseObject.case_information && caseObject.case_information.benefit_investigation && caseObject.case_information.benefit_investigation.length > 0) {
  //     //console.log("downloadFileByCaseId.....",caseObject.case_information.benefit_investigation[0])
  //     downloadRequestForm({}, {},
  //       //  { ref_id: caseObject.case_information.case_id, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-investigation`, ref_type: 'Insurance', skip_pi_investigation: true }
  //       { ref_id: caseObject.case_information.benefit_investigation[0].id, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-investigation`, ref_type: 'Insurance', benefit_type: caseObject.case_information.benefit_investigation[0].benefit_type, skip_pi_investigation: true }

  //     )
  //   }


    //downloadRequestForm({}, {}, { ref_id: caseObject.case_information.case_id, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-request`, ref_type: 'Case' })

    // downloadRequestForm(
    //   {},
    //   {},
    //   { ref_id: insuranceId, type: "investigation", ref_type: "Insurance" }

  //};

  return (
    <div className="card">
      <div className={`card-header ${isPatient ? "" : drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <h4 className={`mb-0 ${isCasePage ? `` : `text-black`}`}>
            {isCasePage ? "Benefits Summary" : "Most Recent Benefits Information"}
          </h4>
          {/* {isCasePage && benefit_summary && (
            <button
              onClick={() => {
                downloadFileByCaseId(benefit_summary && benefit_summary.length > 0 && benefit_summary[0].insurance_id.toString() || "")
              }}
              className="btn btn-link">
              Please click here to download the Benefits Investigations results form full details
            </button>
          )} */}

        </div>
      </div>

      <div className="card-body">
        {!isCasePage && (
          <p>Note: Please download the Benefits Investigations results forms for full details</p>
        )}

        {benefit_summary !== null && coverage_summary !== null ?
          <div>
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th rowSpan={2} className="align-middle">BENEFITS AT A GLANCE</th>
                    <th colSpan={4} className="colspan-head text-center">Primary
                      <span className="border"></span>
                    </th>
                    <th colSpan={4} className="colspan-head text-center">Secondary
                      <span className="border"></span>
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="colspan-head" data-bs-toggle="tooltip" data-bs-placement="right" title={"'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block'"}>
                      Covered<sup>1</sup>
                    </th>
                    <th className="colspan-head">Coinsurance %</th>
                    <th className="colspan-head">Copay $</th>
                    <th className="colspan-head">PA Required</th>
                    <th className="colspan-head" data-bs-toggle="tooltip" data-bs-placement="right" title={"'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block'"}>
                      Covered<sup>1</sup>
                    </th>
                    <th className="colspan-head">Coinsurance %</th>
                    <th className="colspan-head">Copay $</th>
                    <th className="colspan-head">PA Required</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  <tr>
                    <td>Medical</td>
                    <td>
                      {coverage_summary?.qutenza_medical.primary_covered}
                    </td>
                    <td>
                      {
                        coverage_summary &&
                          Number(coverage_summary.qutenza_medical.primary_coverage) > 0
                          ? `${Number(coverage_summary.qutenza_medical.primary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.qutenza_medical.primary_copay}
                    </td>
                    <td>
                      {coverage_summary?.qutenza_medical.primary_pa_req}
                    </td>

                    <td>
                      {coverage_summary?.qutenza_medical.secondary_covered}
                    </td>
                    <td>
                      {
                        coverage_summary &&
                          Number(coverage_summary.qutenza_medical.secondary_coverage) > 0
                          ? `${Number(coverage_summary.qutenza_medical.secondary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.qutenza_medical.secondary_copay}
                    </td>
                    <td>
                      {coverage_summary?.qutenza_medical.secondary_pa_req}
                    </td>

                  </tr>
                  <tr>
                    <td>Administration</td>
                    <td>
                      {coverage_summary?.administeration.primary_covered}
                    </td>
                    <td>
                      {
                        coverage_summary &&
                          Number(coverage_summary.administeration.primary_coverage) > 0
                          ? `${Number(coverage_summary.administeration.primary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.administeration.primary_copay}
                    </td>
                    <td>
                      {coverage_summary?.administeration.primary_pa_req}
                    </td>

                    <td>
                      {coverage_summary?.administeration.secondary_covered}
                    </td>
                    <td>
                      {
                        coverage_summary &&
                          Number(coverage_summary.administeration.secondary_coverage) > 0
                          ? `${Number(coverage_summary.administeration.secondary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.administeration.secondary_copay}
                    </td>
                    <td>
                      {coverage_summary?.administeration.secondary_pa_req}
                    </td>
                  </tr>
                  <tr>
                    <td>Pharmacy</td>
                    <td>
                      {coverage_summary?.qutenza_pharmacy.primary_covered}
                    </td>
                    <td>

                      {
                        coverage_summary &&
                          Number(coverage_summary.qutenza_pharmacy.primary_coverage) > 0
                          ? `${Number(coverage_summary.qutenza_pharmacy.primary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.qutenza_pharmacy.primary_copay}
                    </td>
                    <td>
                      {coverage_summary?.qutenza_pharmacy.primary_pa_req}
                    </td>

                    <td>
                      {coverage_summary?.qutenza_pharmacy.secondary_covered}
                    </td>
                    <td>
                      {
                        coverage_summary &&
                          Number(coverage_summary.qutenza_pharmacy.secondary_coverage) > 0
                          ? `${Number(coverage_summary.qutenza_pharmacy.secondary_coverage)}%`
                          : ""
                      }
                    </td>
                    <td>
                      {coverage_summary?.qutenza_pharmacy.secondary_copay}
                    </td>
                    <td>
                      {coverage_summary?.qutenza_pharmacy.secondary_pa_req}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <p className="fs-6">
                <sup>1</sup> <b>Note:</b> 'Y' indicates covered, 'N' indicates not covered, and 'B' indicates a third-party block
              </p>
            </div>
            <div className="bg-mist">
              {benefit_summary && benefit_summary.length > 0 && benefit_summary.map((item, index) => (
                <div className="p-4 rounded-3 mb-3">
                  <h4 className="mb-3">{item.heading}</h4>
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-4">
                          <span className="fw-semibold me-2">Insurance Name:</span>
                        </div>
                        <div className="col-8">
                          <span className="fw-semibold me-2">{item.insurance_name}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-4">
                          <span className="fw-semibold me-2">Insurance Type:</span>
                        </div>
                        <div className="col-8">
                          <span className="fw-semibold me-2">{item.insurance_type}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <ul className={`nav nav-tabs ${item.out_comment && "d-none"}`} id="networkTab98724" role="tablist">
                      <li className="nav-item">
                        <a className="nav-link active fw-bold" id="inNetwork-tab98724" data-bs-toggle="tab" href="inNetworkTab" data-bs-target="#inNetworkTab" role="tab" aria-controls="inNetworkTab" aria-selected="true">In Network</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link fw-bold" id="outNetwork-tab98724" data-bs-toggle="tab" data-bs-target="#outNetworkTab" href="outNetworkTab" role="tab" aria-controls="outNetworkTab" aria-selected="false">Out of Network</a>
                      </li>
                    </ul>

                    <div className="tab-content" id="networkContent98724">
                      <div className="tab-pane show active" id="inNetworkTab" role="tabpanel" aria-labelledby="inNetworkTab">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <tbody>
                              <tr>
                                <td>
                                  {drug_name?.includes('iovera') ?
                                    <b> C9809 Coinsurance:</b> : <b> J3304 Coinsurance:</b>
                                  }
                                </td>
                                <td>
                                  {item.coverage_J7336} %
                                </td>
                                <td>
                                  {drug_name?.includes('iovera') ?
                                    <b> C9809 Coinsurance:</b> : <b> J3304 Copay:</b>
                                  }
                                </td>
                                <td>$ {item.copay_J7336}</td>

                                <td><b>Deductible:</b></td>
                                <td>$ {item.deductible}</td>
                                <td><b>Out of Packet Max:</b></td>
                                <td>$ {item.out_of_packet_max}</td>
                              </tr>
                              <tr>
                                <td><b>Admin Coinsurance:</b></td>
                                <td>{item.admin_coverage} %</td>
                                <td><b>Admin Copay:</b></td>
                                <td>${item.admin_copay}</td>

                                <td><b>Deductible Met:</b></td>
                                <td>$ {item.deductible_met}</td>
                                <td><b>Out of Pocket Met:</b></td>
                                <td>$ {item.out_of_pocket_met}</td>
                              </tr>
                              <tr>
                                <td><b>Office Coinsurance:</b></td>
                                <td>{item.office_coverage} %</td>
                                <td><b>Office Copay:</b></td>
                                <td>$ {item.office_copay}</td>

                                <td><b>Deductible Remaining:</b></td>
                                <td>$ {item.deductible_remaining}</td>
                                <td><b>Out of Pocket Remaining:</b></td>
                                <td>$ {item.out_of_pocket_remaining}</td>
                              </tr>
                              <tr>
                                <td colSpan={12}><b>Med Ben Notes:</b> {item.med_ben_notes}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="tab-pane show" id="outNetworkTab" role="tabpanel" aria-labelledby="outNetworkTab">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <tbody>
                              <tr>
                                <td><b>Product Coinsurance:</b></td>
                                <td>{item.product_coverage} %</td>
                                <td><b>Product Copay:</b></td>
                                <td>$ {item.product_copay}</td>
                              </tr>
                              <tr>
                                <td><b>Admin Coinsurance:</b></td>
                                <td>{item.admin_coverage_2} %</td>
                                <td><b>Admin copay:</b></td>
                                <td>$ {item.admin_copay_2}</td>
                              </tr>
                              <tr>
                                <td><b>Office Coinsurance:</b></td>
                                <td>{item.office_coverage_2} %</td>
                                <td><b>Office Copay:</b></td>
                                <td>$ {item.office_copay}</td>
                              </tr>
                              <tr>
                                <td><b>Deductible Met:</b></td>
                                <td>$ {item.deductible_met_2}</td>
                                <td><b>Deductible:</b></td>
                                <td>$ {item.deductible_2}</td>
                              </tr>
                              <tr>
                                <td><b>Out of Pocket Met:</b></td>
                                <td>$ {item.out_of_pocket_met_2}</td>
                                <td><b>Deductible:</b></td>
                                <td>$ {item.out_of_packet_max_2}</td>
                              </tr>
                              <tr>
                                <td colSpan={12}><b>Med Ben Notes:</b> {item.medical_benefit_notes}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {pharmacy_benefit_summary && pharmacy_benefit_summary.length > 0 && pharmacy_benefit_summary.map((item, index) => (
                <div className="p-4 rounded-3 mb-3">
                  <h4>{index === 0 ? 'PRIMARY' : 'SECONDARY'} PHARMACY BENEFITS</h4>
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-4">
                          <span className="fw-semibold me-2">Pharmacy Name:</span>
                        </div>
                        <div className="col-8">
                          <span className="fw-semibold me-2">{item.pharmacy_name}</span>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-12 col-md-6">
                      <div className="row">
                        <div className="col-4">
                          <span className="fw-semibold me-2">Insurance Type:</span>
                        </div>
                        <div className="col-8">
                          <span className="fw-semibold me-2">{item.insurance_type}</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="show active">
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <tbody>
                          <tr>
                            <td>
                              <b>Patient RX Coinsurance %:</b>
                            </td>
                            <td>
                              {item.patient_rx_coinsurance}
                            </td>
                            <td>
                              <b>Patient RX Copay:</b>
                            </td>
                            <td>
                              {item.drug_copay}
                            </td>

                          </tr>
                          <tr>
                            <td><b>RX Deductible:</b></td>
                            <td> {item.deductible}</td>
                            <td><b>RX Deductible Met:</b></td>
                            <td> {item.deductible_met}</td>
                          </tr>
                          <tr>
                            <td><b>RX Out of Pocket Max:</b></td>
                            <td>{item.out_of_pocket_max} </td>
                            <td><b>RX Out of Pocket Met:</b></td>
                            <td> {item.out_of_pocket_met}</td>
                          </tr>
                          <tr>
                            <td><b>Pharmacy Benefit Manager (PBM):</b></td>
                            <td>{item.pharmacy_benefit_manager} </td>

                            <td><b>PBM Phone Number:</b></td>
                            <td>{item?.pbm_phone ? formatPhoneNumber(item.pbm_phone) : ""}</td>


                          </tr>
                          <tr>
                            <td colSpan={12}><b>RX Ben Notes:</b> {item.rx_bene_notes}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>))}
            </div>
          </div>
          :
          <div className="alert alert-warning py-2 m-0">
            Benefits are still pending for this case.
          </div>
        }
      </div>
    </div>
  );
};

export default ZilrettaDetailPageInfo;
